import VeeValidate, { Validator } from 'vee-validate'
import store from '../store'

function installRules() {
  Validator.localize({
    en: {
      messages: {
        confirmed: field => 'This field does not match',
        digits: (field, value) => `This field must be exactly contain ${value} digits`,
        email: (field, value) => 'Invalid E-mail address',
        length: (field, value) => `Length should be ${value}`,
        max: (field, value) => `The maximum length is ${value}`,
        min: (field, value) => `The minimum length should be ${value}`,
        max_value: (field, value) => `No more than ${value}`,
        min_value: (field, value) => `At least ${value}`,
        required: field => 'This field cannot be empty',
      },
    },
    id: {
      messages: {
        confirmed: field => 'Tidak cocok',
        digits: (field, value) => `This field must exactly contain ${value} digits`,
        email: (field, value) => 'E-mail tidak valid',
        length: (field, value) => `Panjang harus ${value}`,
        max: (field, value) => `Panjang maksimal adalah ${value}`,
        min: (field, value) => `Panjang minimum adalah ${value}`,
        max_value: (field, value) => `Tidak lebih dari ${value}`,
        min_value: (field, value) => `Minimal ${value}`,
        required: field => 'Tidak boleh kosong',
      },
    },
  })

  const validateRules = {
    betweenLength: {
      messages: {
        en: (field, value) => `This field should be ${value[0]} - ${value[1]} characters`,
        id: (field, value) => `Harus antara ${value[0]} - ${value[1]} karakter`,
      },
      validate(value, args) {
        return value.length >= args[0] && value.length <= args[1]
      },
    },
    multiplesNumber: {
      messages: {
        en: (field, value) => `The amount has to be a multiple of ${value}`,
        id: (field, value) => `Harap masukkan jumlah, jumlah harus merupakan kelipatan ${value}`,
      },
      validate(value, args) {
        if (args[0] === 0) {
          return true
        }
        return value % args[0] === 0
      },
    },
    insufficient: {
      messages: {
        en: (field, value) => 'Insufficient Balance.',
        id: (field, value) => 'Nominal tidak mencukupi',
      },
      validate(value, args) {
        return value <= args[0]
      },
    },
    credentialNumberType: {
      messages: {
        en: (field, value) => '身份证号格式不正确，请重新输入',
      },
      validate(value, args) {
        const regex = new RegExp('^([1-9]\\d{14}|[1-9]\\d{16}[0-9Xx])$')
        return regex.test(value)
      },
    },
    withdrawAll: {
      messages: {
        en: (field, value) => 'Invalid input，please withdraw all of your balance',
        id: (field, value) => 'Jumlah angka tidak valid，silahkan tarik semua nominal Anda',
      },
      validate(value, args) {
        const remain = args[0] - value
        return !(remain > 0 && remain < 10000)
      },
    },
    investRemainLimit: {
      messages: {
        en: (field, value) => 'After funding, unused amount can not be lower than Rp10.000',
        id: (field, value) => 'Setelah pendanaan, sisa uang tidak dapat kurang dari Rp10.000',
      },
      validate(value, args) {
        const remain = args[0] - value
        return !(remain > 0 && remain < 10000)
      },
    },
  }

  // custom validator
  Object.keys(validateRules).forEach(key => {
    Validator.extend(key, validateRules[key].validate)

    // merge the validator messages
    Object.keys(validateRules[key].messages).forEach(locale => {
      Validator.localize({
        [locale]: {
          messages: {
            [key]: validateRules[key].messages[locale],
          },
        },
      })
    })
  })
}

export default {
  install(Vue, options = {}) {
    Vue.use(VeeValidate)
    Validator.localize(store.state.locale)
    installRules()
  },
}
